"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvFormatterStream = void 0;
const stream_1 = require("stream");
const formatter_1 = require("./formatter");
class CsvFormatterStream extends stream_1.Transform {
  formatterOptions;
  rowFormatter;
  hasWrittenBOM = false;
  constructor(formatterOptions) {
    super({
      writableObjectMode: formatterOptions.objectMode
    });
    this.formatterOptions = formatterOptions;
    this.rowFormatter = new formatter_1.RowFormatter(formatterOptions);
    // if writeBOM is false then set to true
    // if writeBOM is true then set to false by default so it is written out
    this.hasWrittenBOM = !formatterOptions.writeBOM;
  }
  transform(transformFunction) {
    this.rowFormatter.rowTransform = transformFunction;
    return this;
  }
  _transform(row, encoding, cb) {
    let cbCalled = false;
    try {
      if (!this.hasWrittenBOM) {
        this.push(this.formatterOptions.BOM);
        this.hasWrittenBOM = true;
      }
      this.rowFormatter.format(row, (err, rows) => {
        if (err) {
          cbCalled = true;
          return cb(err);
        }
        if (rows) {
          rows.forEach(r => {
            this.push(Buffer.from(r, 'utf8'));
          });
        }
        cbCalled = true;
        return cb();
      });
    } catch (e) {
      if (cbCalled) {
        throw e;
      }
      cb(e);
    }
  }
  _flush(cb) {
    this.rowFormatter.finish((err, rows) => {
      if (err) {
        return cb(err);
      }
      if (rows) {
        rows.forEach(r => {
          this.push(Buffer.from(r, 'utf8'));
        });
      }
      return cb();
    });
  }
}
exports.CsvFormatterStream = CsvFormatterStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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